import React__default from 'react';
import { ArticleBody } from './components/article-body.esm.js';
import { ArticleBreadcrumbs } from './components/article-bread-crumbs.esm.js';
import { ArticleDate } from './components/article-date.esm.js';
import { ArticleLeadContent } from './components/article-lead-content.esm.js';
import { templateTypes } from './types.esm.js';

var Article = function Article(props) {
  var _props$messages;
  var isEnterprise = props.data.templateType === templateTypes.enterprise;
  var isVertical = props.data.templateType === templateTypes.vertical;
  return /*#__PURE__*/React__default.createElement("div", {
    "automation-id": "article-main",
    className: "grid gap-y-6"
  }, !isEnterprise && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "flex flex-col items-start justify-between self-stretch pt-4 font-sans text-p-14 leading-6 sm:flex-row sm:items-center md:pt-0"
  }, props.data.breadcrumbs && /*#__PURE__*/React__default.createElement(ArticleBreadcrumbs, {
    breadcrumbElements: props.data.breadcrumbs.breadcrumbElements,
    backLink: props.data.breadcrumbs.backLink
  }), /*#__PURE__*/React__default.createElement(ArticleDate, {
    date: props.data.publishDate
  })), /*#__PURE__*/React__default.createElement(ArticleLeadContent, {
    title: props.data.title,
    summary: props.data.summary,
    leadMedia: props.data.leadMedia,
    categoryBar: props.data.categoryBar,
    isVertical: isVertical,
    messages: props.messages,
    authorByline: props.data.authorByline,
    shareOptions: props.data.shareOptions,
    isMachineTranslation: props.data.isMachineTranslation
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "grid gap-y-10 lg:gap-y-0"
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(ArticleBody, {
    showFullArticle: props.data.showFullArticle,
    body: props.data.body,
    templateType: props.data.templateType,
    promoLabel: (props === null || props === void 0 || (_props$messages = props.messages) === null || _props$messages === void 0 ? void 0 : _props$messages.promoLabel) || 'Related Content'
  }), props.upsellMessage), !isEnterprise && /*#__PURE__*/React__default.createElement("div", {
    "automation-id": "article-footer"
  }, props.data.articleFooter)));
};

export { Article };
//# sourceMappingURL=article.esm.js.map
